import { Directive, ElementRef, Inject, InjectionToken, NgZone, OnInit, Optional } from '@angular/core';
import { eventFindInPath } from '@fi-shared/utils';

export const FiTextItemLinksToPopupOpeners = new InjectionToken('FiTextItemLinksToPopupOpeners');

@Directive({
    selector: '[fi-text-item-links-to-popup]',
    standalone: false,
})
export class FiTextItemLinksToPopupDirective implements OnInit {
    constructor(
        private zone: NgZone,
        private elementRef: ElementRef,
        @Optional() @Inject(FiTextItemLinksToPopupOpeners) private openers: ((model) => boolean)[],
    ) {}

    ngOnInit() {
        // add click listener with capture=true to avoid state change by ccmTextItemLink
        this.elementRef.nativeElement.addEventListener(
            'click',
            (event) => this.zone.run(() => this.onClick(event)),
            true,
        );
    }

    onClick($event: MouseEvent) {
        const link = eventFindInPath($event, 'ccm-text-item-link, a[ccm-text-item-link]');
        if (!link) {
            return;
        }

        const textItemModelJson = link.getAttribute('text-item-model');
        if (!textItemModelJson) {
            return;
        }

        const textItemModel = JSON.parse(textItemModelJson),
            linkToModel = textItemModel.linkTo || textItemModel;

        if (this.openLinkToPopup(linkToModel)) {
            $event.preventDefault();
            $event.stopPropagation();
        }
    }

    openLinkToPopup(linkToModel) {
        if (this.openers) {
            return this.openers.some((callback) => callback(linkToModel));
        }
    }
}
